module.exports = __webpack_public_path__ + "static/img/11.b05459b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/11.png
// module id = pHWY
// module chunks = 0